import {
  SET_HOORY_WIDGET_HIDERS_COUNT,
  SET_TERMINAL_ACCOUNT_MOUNTED
} from 'appRedux/ActionTypes';

export const setTerminalAccountMounted = (data: boolean) => {
  return {
    type: SET_TERMINAL_ACCOUNT_MOUNTED,
    payload: data
  };
};

export const setHooryWidgetHidersCount = (data: {
  hiderType: 'modal' | 'drawer' | 'confirmPopup';
  operation: 'increase' | 'decrease';
}) => {
  return {
    type: SET_HOORY_WIDGET_HIDERS_COUNT,
    payload: data
  };
};
